import {BaseEntity} from './base-entity';
import {MeetingParticipant} from './meeting-participant';
import {SigningEnvelope} from "./signing-envelope";

export class MatterEvent extends BaseEntity {

    constructor(matterEvent?: MatterEvent) {
        super(matterEvent);

        if(matterEvent) {
            this.meetingParticipants = [];

            if(Array.isArray(matterEvent.meetingParticipants) && matterEvent.meetingParticipants.length) {
                this.meetingParticipants = matterEvent.meetingParticipants.filter(itemFilter=>!itemFilter.deleted).map(item=>new MeetingParticipant(item));
            }
        }

    }

    startDate: string;
    startTime: string;
    endTime: string;
    endDate: string;
    eventSubtype: string;
    scheduledForSolicitorName: string;
    eventLocation: string;
    meetingLink: string;
    signingEnvelope: SigningEnvelope;
    meetingParticipants: MeetingParticipant[];
    eventDescription: string;

    isSyngrafii(): boolean {
        return this.signingEnvelope && this.signingEnvelope.digitalSigningPlatform == 'SYNGRAFII';
    }

    isSyngrafiiVirtualSigningRoom(): boolean {
        return this.isSyngrafii() && this.signingEnvelope.packageType == 'VIDEO_SIGNING_ROOM';
    }
}
